import React, { FC } from "react";
import { IconButton } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { useFeatureEditCoordinates } from "./useFeatureEditCoordinates";

export const EditFeatureCoordinatesButton: FC = () => {
  const { t } = useTranslation("featureCard");
  const showEditCoordinatesDialog = useFeatureEditCoordinates();

  return <IconButton kind="xy" title={t("coordinates")} onClick={() => showEditCoordinatesDialog()} />;
};
